import axios from "./axios";

export default {

    /**
     * Add groming related to patient in veterinary
     * @api {POST} veterinarygrooming
     */
     addGroomingToPatient(data) {
        const options = {
            method: 'POST',
            url: 'veterinarypatientgrooming',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Get grooming related to patient
     * @param {string} patientID
     * @returns {Promise}
     */
     getGroomingToPatient(patientID) {
        const options = {
            method: 'GET',
            url: `veterinarypatientgrooming/${patientID}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getGroomingToPatientHistory(patientID) {
        const options = {
            method: 'GET',
            url: `veterinarypatientgrooming/grooming/history/${patientID}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    filterGroomingToPatient({patientID, filter}) {
        const options = {
            method: 'GET',
            url: `veterinarypatientgrooming/filtered/${patientID}`,
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Update Grooming to Patient
     * @api {PUT} veterinarypatientgrooming
     */
     updateGroomingToPatient(id, data) {
        const options = {
            method: 'PUT',
            url: `veterinarypatientgrooming/${id}`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Delete Grooming related to Patient
     * @api {DELETE} veterinarypatientgrooming/:id
     */
     deleteGroomingToPatient(id) {
        const options = {
            method: 'DELETE',
            url: `veterinarypatientgrooming/${id}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    }

}